import { MenuProps } from './Menu.types';

export const menuCSSPropsKeys: (keyof MenuProps)[] = [
  'height',
  'maxHeight',
  'minHeight',
  'maxWidth',
  'minWidth',
  'width',
];
